module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedThinItalic.0b6797b.eot";